import { Component, ErrorInfo, ReactNode } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

interface Props {
  fallback?: ReactNode;
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  reload = () => window.location.reload();

  render() {
    if (!this.state.hasError) return this.props.children;
    if (this.props.fallback) return this.props.fallback;

    return (
      <Container className="mt-5">
        <Row>
          <Col sm={12} className="text-center">
            <FontAwesomeIcon
              icon={faTriangleExclamation}
              size="5x"
              className="mt-5 mb-3 text-danger"
            />
            <h3 className="text-dark mb-3">Something went wrong.</h3>
            {this.state.error?.message && (
              <div className="text-dark mb-3 small">{this.state.error.message}</div>
            )}
            <Button onClick={this.reload}>Reload</Button>
          </Col>
        </Row>
      </Container>
    );
  }
}
